import { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box, Tab } from '@mui/material';
import SuccessCases from '../../ListGroups/SuccessCases';
import { TabGroup } from '../../ListGroups/SuccessCases';
import CaseItem from "./CaseItem";
import { useLocation } from 'react-router-dom';
import ImgModal from './ImgModal';

const Index = () => {
    const location = useLocation();
    const [value, setValue] = useState(location.state?location.state.tabVal:'All');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <FormControl component="article" fullWidth>
                <Grid container>
                    <Grid item style={{ marginLeft: "auto", marginRight: "auto" }} xs={12} md={10} xl={9}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange}>
                                    <Tab label="ALL" value="All" />
                                    {
                                        TabGroup.map((el) => {
                                            return (
                                                <Tab label={el.label} value={el.value} />
                                            );
                                        })
                                    }
                                </TabList>
                            </Box>
                            <TabPanel value="All">
                                {
                                    TabGroup.map((group)=>{
                                        return (
                                            <>
                                            <h2 className="main-header">{group.label}</h2>
                                                {
                                                    SuccessCases.filter(el=>el.tabGroup.findIndex(x=>x==group.value)!=-1).map(function(el,index){
                                                        return (<CaseItem caseEl={el} key={index}/>)
                                                    })
                                                }
                                            </>
                                        );
                                    })
                                }
                            </TabPanel>
                            {
                                TabGroup.map((group) => {
                                    return (
                                        <TabPanel value={group.value}>
                                            <h2 className="main-header">{group.label}</h2>
                                            {
                                                SuccessCases.filter(el=>el.tabGroup.findIndex(x=>x==group.value)!=-1).map(function(el,index){
                                                    return (<CaseItem caseEl={el} key={index}/>)
                                                })
                                            }
                                        </TabPanel>
                                    );
                                })
                            }
                        </TabContext>
                    </Grid>
                </Grid>
            </FormControl>
            <ImgModal/>
        </>

    );
}

export default Index;